import { z } from "zod";

const streamProviderEnum = z.enum(["YOUTUBE", "TWITCH", "KICK"] as const);

export const zStreamingChannelInput = z.object({
    externalChannelHandle: z.string(),
    externalChannelId: z.string(),
    provider: streamProviderEnum,
    imageId: z.string().nullable(),
});

export type StreamingChannelInput = z.infer<typeof zStreamingChannelInput>;
